import { createAction, props } from '@ngrx/store';
import { Event, PageData } from '../../models';

export const LoadEvents = createAction('[Content] Load Events', props<{ profileId?: number; take?: number; skip?: number }>());
export const LoadEventsSuccess = createAction('[Content] Load Events Success', props<{ events: { items: Event[]; page: PageData } }>());
export const LoadEventsFail = createAction('[Content] Load Events Fail', props<{ error: any }>());

export const LoadEventsOverview = createAction(
  '[Content] Load Events Overview',
  props<{ profileId?: number; take?: number; skip?: number }>()
);
export const LoadEventsOverviewSuccess = createAction(
  '[Content] Load Events Overview Success',
  props<{ events: { items: Event[]; page: PageData } }>()
);
export const LoadEventsOverviewFail = createAction('[Content] Load Events Overview Fail', props<{ error: any }>());

export const ResetEvents = createAction('[Content] Reset Events');

export const LoadEventDetail = createAction('[Content] Load Event', props<{ id: number }>());
export const LoadEventDetailSuccess = createAction('[Content] Load Event Success', props<{ event: Event }>());
export const LoadEventDetailFail = createAction('[Content] Load Event Fail', props<{ error: any }>());
